import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Gift } from 'lucide-react';

function daysUntil(iso) {
  if (!iso) return null;
  const ms = new Date(iso).getTime() - Date.now();
  return Math.max(0, Math.ceil(ms / 86400000));
}

export default function PackageAccessBanner({ sub }) {
  if (!sub?.granted_by_admin) return null;
  const daysLeft = daysUntil(sub.current_period_end);
  if (daysLeft === null) return null;
  const note = sub.grant_note || 'Coaching package';

  return (
    <Card className="border-2 border-[#004C54]/30 bg-gradient-to-r from-[#F0F4F4] via-white to-[#E6F4F6]" data-testid="package-access-banner">
      <CardContent className="p-4 sm:p-5">
        <div className="flex items-start gap-3 sm:items-center">
          <div className="w-10 h-10 rounded-lg bg-[#004C54] text-white flex items-center justify-center shrink-0">
            <Gift className="h-4 w-4" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="font-mono-accent uppercase tracking-[0.2em] text-[10px] text-[#004C54] font-semibold mb-1">
              Your coaching package
            </div>
            <div className="font-heading text-[15px] font-bold leading-tight" data-testid="package-access-title">
              {note}
            </div>
            <div className="text-[13px] text-foreground/65 mt-0.5">
              Full app access · <span className="font-semibold text-foreground">{daysLeft} day{daysLeft === 1 ? '' : 's'}</span> remaining
              {sub.current_period_end && <span className="text-foreground/45"> · expires {new Date(sub.current_period_end).toLocaleDateString()}</span>}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
